import React from "react";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";
import bgImage from "../../assests/images/login-bg.jpg"; // Place a background image in public or src/assets
import Cookies from 'js-cookie';

const allowedEmails = [
  "ddabroad.kpsgroup@gmail.com",
  "speakerend@gmail.com",
  "dreamdestinationabroad@gmail.com"
];

const NewLogin = () => {
  const navigate = useNavigate();

  const handleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const email = result.user.email;

      if (allowedEmails.includes(email)) {
        console.log("Access granted to:", email);
        Cookies.set("ddabroad_google_email", email, { expires: 1 });
        console.log("set")
        navigate("/dashboard");
        console.log("redirected")
      } else {
        alert("Access denied. Your email is not authorized.");
      }
    } catch (err) {
      console.error("Login Error:", err);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        color: "#fff",
        textShadow: "1px 1px 2px #000",
        textAlign: "center"
      }}
    >
      <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>Welcome to KPS Enterprises</h1>
      <p style={{ marginBottom: "1rem" }}>
        Sign in using your authorized Google account to continue.
      </p>
      <button
        onClick={handleLogin}
        style={{
          padding: "10px 20px",
          backgroundColor: "#4285F4",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: "1rem"
        }}
      >
        Sign in with Google
      </button>
      <div style={{ marginTop: "1.5rem", fontSize: "0.9rem" }}>
        <strong>Checklist:</strong>
        <ul>
          <li>✔ Valid Google Account</li>
          <li>✔ Email whitelisted</li>
          <li>✔ Internet Connectivity</li>
        </ul>
      </div>
    </div>
  );
};

export default NewLogin;
